(function () {
  /*
   * Prevent this script from being initialised more than once.
   */
  if (window.__wildEssenceIconInsertionStarted) {
    return;
  }

  window.__wildEssenceIconInsertionStarted = true;

  /*
   * Capture the URL of this JavaScript asset while it is executing.
   * The SVG sits in the same Shopify theme Assets folder, so its
   * correct URL can be created from the JavaScript asset URL.
   */
  const currentScript =
    document.currentScript ||
    Array.from(document.scripts).find((script) => {
      return (
        script.src &&
        script.src.includes("/assets/") &&
        (
          script.src.includes("/cdn/shop/t/") ||
          script.src.includes("cdn.shopify.com/s/files/")
        )
      );
    });

  const scriptURL = currentScript && currentScript.src
    ? currentScript.src
    : "";

  const iconURL = scriptURL
    ? new URL(
        "wild-essence-icon_acacia.svg",
        scriptURL
      ).href
    : "";

  const brandName = "Wild Essence";

  const allSelectors = [
    ".product-card a",
    ".product-grid__item h2",
    ".collection-grid-item__title",
    ".product-title",
    "a.full-unstyled-link",
    ".card__information a",
    ".site-nav a",
    ".header__menu-item",
    ".announcement-bar__message",
    ".footer a",
    "nav a",
    "p",
    "li",
    "span",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    ".slideshow__text",
    ".slideshow__title",
    ".slideshow__button",
    ".slider .title",
    ".slider a",
    ".hero__text",
    ".banner__content",
    ".banner__heading",
    "a.button",
    "a"
  ];

  const combinedSelector = allSelectors.join(", ");

  /*
   * Check whether a node is an icon that this script already inserted.
   */
  function isWildEssenceIcon(node) {
    return (
      node instanceof HTMLImageElement &&
      node.dataset.wildEssenceIcon === "true"
    );
  }

  /*
   * Create one decorative Wild Essence icon.
   */
  function createIconElement() {
    const img = document.createElement("img");

    img.src = iconURL;

    /*
     * The text "Wild Essence" already appears directly before the icon.
     * Empty alt text prevents screen readers and broken-image fallback
     * text from repeating the brand name.
     */
    img.alt = "";
    img.setAttribute("aria-hidden", "true");

    img.dataset.wildEssenceIcon = "true";
    img.className = "wild-essence-inline-icon";

    img.style.display = "inline-block";
    img.style.width = "1em";
    img.style.height = "1em";
    img.style.marginLeft = "0.3em";
    img.style.verticalAlign = "middle";
    img.style.objectFit = "contain";

    /*
     * If the icon ever fails to load, remove it rather than showing
     * the browser's broken-image symbol.
     */
    img.addEventListener(
      "error",
      function () {
        console.error(
          "The Wild Essence icon could not be loaded:",
          iconURL
        );

        img.remove();
      },
      { once: true }
    );

    return img;
  }

  /*
   * Add the icon after every direct text occurrence of "Wild Essence"
   * inside a selected element.
   */
  function addIconSafely(element) {
    if (!(element instanceof Element)) {
      return;
    }

    const childNodes = Array.from(element.childNodes);

    childNodes.forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) {
        return;
      }

      const text = node.textContent || "";

      if (!text.includes(brandName)) {
        return;
      }

      /*
       * Do not add another icon when this occurrence has already
       * been processed.
       */
      if (
        text === brandName &&
        isWildEssenceIcon(node.nextSibling)
      ) {
        return;
      }

      const parts = text.split(brandName);
      const fragment = document.createDocumentFragment();

      parts.forEach((part, index) => {
        if (part) {
          fragment.appendChild(
            document.createTextNode(part)
          );
        }

        if (index < parts.length - 1) {
          fragment.appendChild(
            document.createTextNode(brandName)
          );

          fragment.appendChild(
            createIconElement()
          );
        }
      });

      node.replaceWith(fragment);
    });
  }

  /*
   * Process one selected page element.
   */
  function processElement(element) {
    if (!(element instanceof Element)) {
      return;
    }

    if (
      !element.textContent ||
      !element.textContent.includes(brandName)
    ) {
      return;
    }

    addIconSafely(element);
  }

  /*
   * Process a root element and all matching elements inside it.
   */
  function processWithin(root) {
    if (!root) {
      return;
    }

    if (
      root instanceof Element &&
      root.matches(combinedSelector)
    ) {
      processElement(root);
    }

    if (typeof root.querySelectorAll === "function") {
      root
        .querySelectorAll(combinedSelector)
        .forEach(processElement);
    }
  }

  /*
   * Start processing the page and watch for content that Shopify,
   * sliders, filters or other scripts add later.
   */
  function initialiseIconInsertion() {
    processWithin(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        /*
         * Handle text that changes inside an existing element.
         */
        if (mutation.type === "characterData") {
          const parent = mutation.target.parentElement;

          if (
            parent &&
            parent.matches(combinedSelector)
          ) {
            processElement(parent);
          }

          return;
        }

        /*
         * Handle newly added elements and text nodes.
         */
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            processWithin(node);
            return;
          }

          if (node.nodeType === Node.TEXT_NODE) {
            const parent = node.parentElement;

            if (
              parent &&
              parent.matches(combinedSelector)
            ) {
              processElement(parent);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    /*
     * One additional pass for sliders and sections that initialise
     * shortly after the page has loaded.
     */
    window.setTimeout(() => {
      processWithin(document);
    }, 1500);
  }

  /*
   * Do not place icons on the page until the SVG URL has been
   * confirmed to work.
   */
  function start() {
    if (!iconURL) {
      console.error(
        "The Wild Essence script could not determine its Shopify asset URL."
      );

      return;
    }

    const preloadImage = new Image();

    preloadImage.addEventListener(
      "load",
      initialiseIconInsertion,
      { once: true }
    );

    preloadImage.addEventListener(
      "error",
      function () {
        console.error(
          "The Wild Essence SVG was not found at:",
          iconURL
        );
      },
      { once: true }
    );

    preloadImage.src = iconURL;
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      { once: true }
    );
  } else {
    start();
  }
})();